export default __webpack_public_path__ + "static/media/KeyImageBackground.e2edb431.svg";